export const ROUTE_SETTINGS = '/settings';
